 document.addEventListener('DOMContentLoaded', function () {
            const mobileNav = document.getElementById('mobileNav');
            const navTabs = mobileNav.querySelectorAll('.nav-tab');
            const navLinks = mobileNav.querySelectorAll('.nav-link');
            const allPanels = mobileNav.querySelectorAll('.nav-panel');

            // Header elements
            const mainHeader = document.getElementById('mainHeader');
            const navBackBar = document.getElementById('navBackBar');
            const navBackButton = document.getElementById('navBackButton');
            const navBackTitle = document.getElementById('navBackTitle');
            
            let navHistory = ['shop']; // Start with the initial active panel

            // --- HEADER UPDATE LOGIC ---
            function updateHeader() {
                if (navHistory.length <= 1) {
                    // We are at the top level
                    navBackBar.style.display = 'none';
                    mainHeader.style.borderBottom = 'none';
                } else {
                    // We are in a sub-level
                    navBackBar.style.display = 'flex';
                    mainHeader.style.borderBottom = '1px solid #374151'; // gray-700
                    
                    const parentPanelId = navHistory[navHistory.length - 2];
                    const parentPanel = document.getElementById(parentPanelId);
                    if (parentPanel) {
                       navBackTitle.textContent = parentPanel.dataset.title.toUpperCase();
                    }
                }
            }

            // --- TAB SWITCHING ---
            navTabs.forEach(tab => {
                tab.addEventListener('click', () => {
                    const targetPanelId = tab.dataset.tabTarget;
                    
                    // Reset history to the new root panel
                    navHistory = [targetPanelId];
                    
                    // Reset all panels
                    allPanels.forEach(p => {
                        p.classList.remove('active', 'is-moving-left');
                    });

                    // Activate the target panel
                    document.getElementById(targetPanelId).classList.add('active');

                    // Update tab styles
                    navTabs.forEach(t => {
                        t.classList.remove('active-tab', 'bg-yellow-400', 'text-black');
                        t.classList.add('bg-gray-700', 'text-gray-400');
                    });
                    tab.classList.add('active-tab', 'bg-yellow-400', 'text-black');
                    tab.classList.remove('bg-gray-700', 'text-gray-400');
                    
                    updateHeader();
                });
            });

            // --- NAVIGATION FORWARD ---
            navLinks.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    const targetPanelId = link.dataset.target;
                    const targetPanel = document.getElementById(targetPanelId);
                    const currentPanelId = navHistory[navHistory.length - 1];
                    const currentPanel = document.getElementById(currentPanelId);

                    if (targetPanel && currentPanel) {
                        currentPanel.classList.add('is-moving-left');
                        currentPanel.classList.remove('active');
                        targetPanel.classList.add('active');
                        
                        navHistory.push(targetPanelId);
                        updateHeader();
                    }
                });
            });

            // --- NAVIGATION BACKWARD ---
            navBackButton.addEventListener('click', (e) => {
                e.preventDefault();
                if (navHistory.length <= 1) return;

                const currentPanelId = navHistory.pop();
                const targetPanelId = navHistory[navHistory.length - 1];
                
                const currentPanel = document.getElementById(currentPanelId);
                const targetPanel = document.getElementById(targetPanelId);

                if (currentPanel && targetPanel) {
                    currentPanel.classList.remove('active');
                    targetPanel.classList.remove('is-moving-left');
                    targetPanel.classList.add('active');
                    updateHeader();
                }
            });

            // Initial call
            updateHeader();
        });